import type { ConfigDto } from "src/types";
import { rootApi } from "./rootApi";

// `adminRoleNames` is intersected in here rather than added to the generated `ConfigDto` type
// directly, because the generated type only picks it up after `npm run generate-types:local` is
// next run against the updated backend - same technique already used in usersApi.ts.
export const configApi = rootApi.injectEndpoints({
    endpoints: (build) => ({
        getConfig: build.query<ConfigDto & { adminRoleNames: string[] }, void>({
            query: () => "config",
        }),
    }),
});

export const { useGetConfigQuery, useLazyGetConfigQuery } = configApi;
